import React, { useEffect, useMemo, useState } from 'react';
import taskService from '../../services/taskService';
import { toast } from 'react-hot-toast';
import { employeeService } from '../../services/employeeService';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', description: '' });
  const [activeProject, setActiveProject] = useState(null);
  const [employees, setEmployees] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const p = await taskService.listProjects();
      setProjects(p.data?.projects || p.projects || []);
    } catch (e) {
      console.error(e);
      toast.error('Failed to load projects');
    } finally {
      setLoading(false);
    }
  };

  const loadEmployees = async () => {
    try {
      const res = await employeeService.getEmployees({ page: 1, limit: 100 });
      setEmployees(res.data?.employees || res.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => { load(); loadEmployees(); }, []);

  const createProject = async (e) => {
    e.preventDefault();
    try { await taskService.createProject(form); setShowForm(false); setForm({ name: '', description: '' }); load(); toast.success('Project created'); }
    catch (e) { toast.error('Create project failed'); }
  };

  const openProject = (p) => setActiveProject(p);
  const addMember = async (projectId, userId, role='contributor') => {
    try { await taskService.addProjectMember(projectId, userId, role); toast.success('Member added'); load(); }
    catch (e) { toast.error('Add member failed'); }
  };
  const removeMember = async (projectId, userId) => {
    if (!confirm('Remove member?')) return;
    try { await taskService.removeProjectMember(projectId, userId); toast.success('Member removed'); load(); }
    catch (e) { toast.error('Remove member failed'); }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Projects</h1>
            <p className="text-gray-600">Create projects and manage members</p>
          </div>
          <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={() => setShowForm(true)}>New Project</button>
        </div>

        {loading ? (
          <div className="p-6 text-center">Loading...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {projects.map(p => (
              <div key={p.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                <div className="font-semibold">{p.name}</div>
                <div className="text-sm text-gray-500">{p.description || 'No description'}</div>
                <div className="mt-3">
                  <div className="text-xs font-medium mb-1">Members</div>
                  <div className="space-y-1">
                    {(p.Members || []).map(m => (
                      <div key={m.id} className="flex items-center justify-between text-sm">
                        <span>{m.User?.firstName} {m.User?.lastName} • {m.role}</span>
                        <button className="text-red-600" onClick={() => removeMember(p.id, m.userId)}>Remove</button>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-3">
                  <select className="border rounded px-2 py-1 w-full" onChange={(e) => addMember(p.id, e.target.value)} defaultValue="">
                    <option value="" disabled>Add member…</option>
                    {employees.map(emp => (
                      <option key={emp.id} value={emp.userId}>{emp.User?.firstName} {emp.User?.lastName}</option>
                    ))}
                  </select>
                </div>
                <div className="mt-3">
                  <a className="text-blue-600" href={`/projects/${p.id}`}>Open</a>
                </div>
              </div>
            ))}
          </div>
        )}

        {showForm && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow p-6 w-full max-w-lg">
              <h2 className="text-lg font-semibold mb-4">New Project</h2>
              <form onSubmit={createProject} className="space-y-3">
                <input className="border rounded px-3 py-2 w-full" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                <textarea className="border rounded px-3 py-2 w-full" rows={3} placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
                <div className="flex justify-end space-x-2 pt-2">
                  <button type="button" className="px-4 py-2 border rounded" onClick={() => setShowForm(false)}>Cancel</button>
                  <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded">Create</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;


